<!-- @format -->

<div class="paginationControlContainer">
	<div class="paginationControl" #paginationControl>
		<!-- Render it in the elongated list mode -->
		<ng-container *ngIf="paginationDisplayStyle === DisplayStyles.Inline">
			<button class="firstPageBtn" (click)="goToFirstPage()" [disabled]="shouldDisablePrevBtns">
				<i class="fa-solid fa-chevrons-left"></i>
				<span>&nbsp;First</span>
			</button>

			<button class="previousPageBtn" (click)="goToPrevPage()" [disabled]="shouldDisablePrevBtns">
				<i class="fa-solid fa-chevron-left"></i>
				<span>&nbsp;Previous</span>
			</button>

			<div class="paginationPageNumberContainer">
				<ng-container *ngIf="currentListDisplayed === DisplayedList.Initial">
					<ng-container *ngFor="let pageNum of paginationKeysStart">
						<div (click)="goToSpecificPage(pageNum)" class="{{paginationCurrentPage === pageNum ? 'currentPaginationPage' : ''}}">
							<span>{{pageNum}}</span>
						</div>
					</ng-container>

					<ng-container *ngIf="!paginationKeysStart.includes(paginationLastPage)">
						<div class="ellipses">...</div>
						<div class="{{paginationCurrentPage === paginationLastPage ? 'currentPaginationPage' : ''}}" (click)="goToLastPage()">
							<span>{{paginationLastPage}}</span>
						</div>
					</ng-container>
				</ng-container>

				<ng-container *ngIf="currentListDisplayed === DisplayedList.Middle">
					<div (click)="goToFirstPage()"><span>1</span></div>
					<div class="ellipses">...</div>
					<div class="prevPageNumber" (click)="goToPrevPage()">
						<span>{{paginationCurrentPage - 1}}</span>
					</div>
					<div class="currentPaginationPage">
						<span>{{paginationCurrentPage}}</span>
					</div>
					<div class="nextPageNumber" (click)="goToNextPage()">
						<span>{{paginationCurrentPage + 1}}</span>
					</div>
					<div class="ellipses">...</div>
					<div (click)="goToLastPage()">
						<span>{{paginationLastPage}}</span>
					</div>
				</ng-container>

				<ng-container *ngIf="currentListDisplayed === DisplayedList.Final">
					<div (click)="goToFirstPage()"><span>1</span></div>
					<div class="ellipses">...</div>

					<ng-container *ngFor="let pageNum of paginationKeysEnd">
						<div class="{{paginationCurrentPage === pageNum ? 'currentPaginationPage' : ''}}" (click)="goToSpecificPage(pageNum)">
							<span>{{pageNum}}</span>
						</div>
					</ng-container>
				</ng-container>
			</div>

			<button class="nextPageBtn" (click)="goToNextPage()" [disabled]="shouldDisableNextBtns">
				<span>Next&nbsp;</span>
				<i class="fa-solid fa-chevron-right"></i>
			</button>

			<button class="lastPageBtn" (click)="goToLastPage()" [disabled]="shouldDisableNextBtns">
				<span>Last&nbsp;</span>
				<i class="fa-solid fa-chevrons-right"></i>
			</button>
		</ng-container>

		<!-- Render it in the stacked list mode -->
		<ng-container *ngIf="paginationDisplayStyle === DisplayStyles.Stacked">
			<div class="stackedPaginationControls">
				<div class="paginationPageNumberContainer">
					<ng-container *ngIf="currentListDisplayed === DisplayedList.Initial">
						<ng-container *ngFor="let pageNum of paginationKeysStart">
							<div class="{{paginationCurrentPage === pageNum ? 'currentPaginationPage' : ''}}" (click)="goToSpecificPage(pageNum)">
								<span>{{pageNum}}</span>
							</div>
						</ng-container>

						<ng-container *ngIf="!paginationKeysStart.includes(paginationLastPage)">
							<div class="ellipses">...</div>
							<div class="{{paginationCurrentPage === paginationLastPage ? 'currentPaginationPage' : ''}}" (click)="goToLastPage()">
								<span>{{paginationLastPage}}</span>
							</div>
						</ng-container>
					</ng-container>

					<ng-container *ngIf="currentListDisplayed === DisplayedList.Middle">
						<ng-container *ngIf="paginationNumberListSize === DisplayModes.Full">
							<div (click)="goToFirstPage()"><span>1</span></div>
						</ng-container>

						<div class="ellipses">...</div>
						<div class="prevPageNumber" (click)="goToPrevPage()">
							<span>{{paginationCurrentPage - 1}}</span>
						</div>
						<div class="currentPaginationPage">
							<span>{{paginationCurrentPage}}</span>
						</div>
						<div class="nextPageNumber" (click)="goToNextPage()">
							<span>{{paginationCurrentPage + 1}}</span>
						</div>
						<div class="ellipses">...</div>

						<ng-container *ngIf="paginationNumberListSize === DisplayModes.Full">
							<div (click)="goToLastPage()">
								<span>{{paginationLastPage}}</span>
							</div>
						</ng-container>
					</ng-container>

					<ng-container *ngIf="currentListDisplayed === DisplayedList.Final">
						<div (click)="goToFirstPage()"><span>1</span></div>
						<div class="ellipses">...</div>

						<ng-container *ngFor="let pageNum of paginationKeysEnd">
							<div class="{{paginationCurrentPage === pageNum ? 'currentPaginationPage' : ''}}" (click)="goToSpecificPage(pageNum)">
								<span>{{pageNum}}</span>
							</div>
						</ng-container>
					</ng-container>
				</div>

				<div class="paginationCompressedNavBtns">
					<div class="paginationNavBtnsLeft">
						<button class="firstPageBtn" (click)="goToFirstPage()" [disabled]="shouldDisablePrevBtns">
							<i class="fa-solid fa-chevrons-left"></i>
						</button>

						<button class="previousPageBtn" (click)="goToPrevPage()" [disabled]="shouldDisablePrevBtns">
							<i class="fa-solid fa-chevron-left"></i>
						</button>
					</div>

					<div class="paginationNavBtnsRight">
						<button class="nextPageBtn" (click)="goToNextPage()" [disabled]="shouldDisableNextBtns">
							<i class="fa-solid fa-chevron-right"></i>
						</button>

						<button class="lastPageBtn" (click)="goToLastPage()" [disabled]="shouldDisableNextBtns">
							<i class="fa-solid fa-chevrons-right"></i>
						</button>
					</div>
				</div>
			</div>
		</ng-container>
	</div>
</div>
